<template>
  <div class="side_box">
    <div>
      <label for="lotbon">{{ this.item.bonID == "" ? 'LOT' : 'Batch'}}</label>
      <span v-if="this.item.bonID || this.item.lotID">{{ this.item.bonID == "" ? this.item.lotID : this.item.bonID}}</span>
      <span v-else>/</span>
    </div>

    <div class="shared shared-2">
      <div>
        <label for="employee">Operator</label>
        <span v-if="this.item.firstName && this.item.lastName">{{ this.item.firstName.charAt(0) + '.  ' + this.item.lastName}}</span>
        <span v-else>/</span>
      </div>

      <div>
        <label for="date">Date</label>
        <span v-if="this.item.dateCreated">{{ this.item.dateCreated | formatDate}}</span>
        <span v-else>/</span>
      </div>
    </div>

    <div class="shared shared-2">
      <div>
        <label for="DHRREF">Prod. REF</label>
        <span v-if="this.item.DHRREF">{{ this.item.DHRREF }}</span>
        <span v-else>/</span>
      </div>

      <div>
        <label for="location">Quantity</label>
        <span v-if="this.item.amount">{{ this.item.amount }}</span>
        <span v-else>/</span>
      </div>
    </div>

    <div>
      <label for="ref">Status</label>
      <span v-if="this.item.created == 1 && this.item.finished == 0" class="status-card  in-progress">In Progress</span>
      <span v-if="this.item.finished == 1 && this.item.approved == 0" class="status-card  completed">Completed</span>
      <span v-if="this.item.dateCreated != this.item.dateApproved" class="status-card  approved">Approved</span>
    </div>
    <div class="detail-button-group">
      <router-link v-if="this.item.bonID == ''" class="button-dhr" :to="'/production/dhr/' + this.item.DHRID + '/' + this.item.lotID">View full DHR</router-link>
      <router-link v-if="this.item.lotID == ''" class="button-dhr" :to="'/production/dhr/' + this.item.DHRID + '/' + this.item.bonID">View full DHR</router-link>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
  },
  props: {
    item: Object
  },
};
</script>

<style lang="scss" scoped>  
@import "@/style/base.scss";
@import "@/style/components/sideBox.scss";

.side_box {
  max-height: 440px;
}

span.status-card {
  width: 104px;
  height: auto;
  padding: 8px 0;
  border-radius: 6px;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 12px;
  text-align: center;

  &.approved {
    background-color: #E9F9EA;
    color: #2AA328;
  }
  &.completed {
    background-color: #D6E9FC;
    color: #3390F2;
  }
  &.in-progress {
    background-color: #FDECD9;
    color: #D08F40;
  }
}

.detail-button-group {
  padding-top: 24px;
}

.button-dhr {
  font-family: "Montserrat", sans-serif;
  display: flex;
  justify-content: space-evenly;
  background-color: #03758b;

  font-weight: 600;
  font-size: 16px;
  border: none;
  padding: 14px 40px;
  color: white !important;
  border-radius: 6px;
  transition: background-color 0.25s ease;

  display: flex;
  align-items: center;
  cursor: pointer;

  user-select: none;

  &:hover {
    text-decoration: none;
    color: white !important;
    background-color: #03758b !important;
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16) !important;
  }
}
</style>
